import React from 'react';
import { logger } from "../../utils/logger";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    logger.error("Uncaught error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          width: '100vw',
          backgroundColor: '#f8f9fa',
          color: '#333',
          fontFamily: 'Arial, sans-serif',
          textAlign: 'center',
          padding: '20px'
        }}>
          <div style={{
            backgroundColor: '#fff',
            padding: '40px',
            borderRadius: '12px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
            maxWidth: '500px'
          }}>
            <h1 style={{ color: '#d9534f', marginBottom: '20px' }}>Oops! Something went wrong</h1>
            <p style={{ fontSize: '18px', marginBottom: '30px' }}>
              The application encountered an unexpected error. Please try refreshing the page or contact support if the issue persists.
            </p>
            <button 
              onClick={() => window.location.assign("/")}
              style={{
                backgroundColor: '#0c66af',
                color: 'white',
                border: 'none',
                padding: '12px 24px',
                borderRadius: '6px',
                fontSize: '16px',
                cursor: 'pointer',
                transition: 'background-color 0.2s'
              }}
              onMouseOver={(e) => e.target.style.backgroundColor = '#084d84'}
              onMouseOut={(e) => e.target.style.backgroundColor = '#0c66af'}
            >
              Go to Home
            </button>
            
            {process.env.NODE_ENV === 'development' && (
              <div style={{ marginTop: '30px', textAlign: 'left' }}>
                <p><strong>Error Details (Dev Mode only):</strong></p>
                <div style={{
                  backgroundColor: '#f1f1f1',
                  padding: '10px',
                  borderRadius: '4px',
                  fontSize: '12px',
                  overflowX: 'auto',
                  maxHeight: '200px'
                }}>
                  <pre>{this.state.error && this.state.error.toString()}</pre>
                </div>
              </div>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
